module.exports = __webpack_public_path__ + "static/media/luis-claudio.f76d6de2.png";